import { Injectable } from "@angular/core";
import { idField, ReferenceField } from "@common/references/reference-field";
import { UtilityRate } from "./utility-rate.interfaces";
import { DefaultService } from "@common/references/default.service";
import urlJoin from "url-join";
import { environment } from "@environments/environment";
import {
  UtilityRateFormComponent
} from '@modules/settings/utility-rates/utility-rate-form/utility-rate-form.component';

@Injectable({
  providedIn: "root",
})
export class UtilityRatesService extends DefaultService<UtilityRate> {
  backendName = 'utility-rates';
  formComponent = UtilityRateFormComponent;
  title = 'MENU.UTILITY_RATES';
  titleSingular = 'UTILITY_RATES';

  fields: ReferenceField[] = [
    idField,
    {
      fieldName: 'building',
      label: 'BUILD_DASHBOARD.PROPERTY',
      iconClass: 'las la-building',
      fieldValue: (item) => item.address,
      filter: true
    },
    {
      fieldName: 'utilityProvider',
      label: 'MENU.UTILITY_PROVIDERS',
      iconClass: 'las la-cube',
      fieldValue: (item,data) => data?.utilityProviderType?.utilityProvider?.name,
      filter: true
    },
    {
      fieldName: 'utilityProviderType',
      label: 'METER_TYPE.UTILITY_TYPE',
      iconClass: 'las la-cube',
      viewType: 'unitType',
      filter: true
    },
    {fieldName: 'price', label: 'TARIFFS.PRICE', iconClass: 'las la-euro-sign', filter: true},
    {fieldName: 'taxRate', label: 'UTILITYRATES.TAXRATE', iconClass: 'las la-percentage', filter: true},
    {fieldName: 'status', label: 'USERS.STATUS', viewType: 'status', filter: {type: "boolean"}},
  ];
  hasActions = true;
  hasAdd = true;
  hasDelete = true;

  getUrl(): string {
    return urlJoin(environment.apiUrl, 'utility-rates');
  }
}
